import React, { useContext, createContext } from 'react';
const Context = createContext({});
export default function ToggleMappingProvider({ children, value }) {
    return <Context.Provider value={value}>{children}</Context.Provider>;
}

export function useToggleMapping() {
    const value = useContext(Context);
    return value;
}
